var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7h22s1.5 0 1.5-1.5S25 4 25 4h-3.512c-.733 0-1.1 0-1.446-.083a3.001 3.001 0 0 1-.867-.36c-.303-.185-.562-.444-1.08-.963l-.19-.188c-.518-.519-.777-.778-1.08-.964a3.001 3.001 0 0 0-.867-.36C15.612 1 15.245 1 14.512 1h-1.024c-.733 0-1.1 0-1.446.083a3.001 3.001 0 0 0-.867.36c-.303.185-.562.444-1.08.963l-.19.188c-.518.519-.777.778-1.08.964a3 3 0 0 1-.867.36C7.612 4 7.246 4 6.512 4H3S1.5 4 1.5 5.5 3 7 3 7Zm1.5 3 1.169 9.935c.294 2.5.44 3.75 1.023 4.692a5 5 0 0 0 2.142 1.905c1.004.468 2.263.468 4.78.468h.772c2.517 0 3.776 0 4.78-.468a5 5 0 0 0 2.142-1.905c.582-.942.73-2.192 1.023-4.692L23.5 10h-19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete28);
export default __webpack_public_path__ + "static/media/delete_28.1b2fe714.svg";
export { ForwardRef as ReactComponent };